/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-filename-extension */
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { DefaultButton, PrimaryButton, Stack, TextField, ITextFieldProps, mergeStyles } from '@fluentui/react';
import React, { FC, useContext, useState } from 'react';

export interface BulkAddEditorProps {
  className?: string;
  onSubmit(bulkValues: string[]): void;
  onCancel(): void;
}

function formatRawString(value: string) {
  const values = value.split(/[\n\r]/).map(str => str.trim()).filter(str => str !== '');
  const unqiue = new Set();
  const res: string[] = [];
  values.forEach((v) => {
    if (!unqiue.has(v.toLowerCase())) {
      unqiue.add(v);
      res.push(v);
    }
  });
  return res;
}

const bulkAddEditorStyleClassName = mergeStyles({
  display: 'flex',
  flexDirection: 'column',
  '& .bulk-add-editor-textarea': {
    paddingLeft: 16,
    paddingRight: 16,
  },
});

// This component is only used for add new bulk-enabled values
export const BulkAddEditor: FC<BulkAddEditorProps> = (props) => {
  const {
    className,
    onCancel,
    onSubmit,
  } = props;
  const i18n: any = useContext(I18nContext);

  const [value, setValue] = useState<string | undefined>('');

  function onClickSubmit() {
    const finalValues = formatRawString(value ?? '');
    onSubmit(finalValues);
  }

  function onClickCancel() {
    onCancel();
  }

  const onValueChange: ITextFieldProps['onChange'] = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={`bulk-add-editor ${className} ${bulkAddEditorStyleClassName}`}>
      <TextField placeholder={i18n.getString(_TL_('Enter one value per line.'))} className="bulk-add-editor-textarea" multiline rows={3} value={value} onChange={onValueChange} />
      <div className="bulk-add-editor-actions">
        <Stack horizontal tokens={{ childrenGap: 12, padding: 16 }}>
          <PrimaryButton onClick={onClickSubmit}>{i18n.getString(_TL_('Submit'))}</PrimaryButton>
          <DefaultButton onClick={onClickCancel}>{i18n.getString(_TL_('Cancel'))}</DefaultButton>
        </Stack>
      </div>
    </div>
  );
};
